import { withRouter } from "react-router-dom";


const Analytics = ({ history }) => {


    return (
        null
    )

}

export default (withRouter(Analytics))
